import { render } from "./VODFolderManage.vue?vue&type=template&id=58492962&scoped=true"
import script from "./VODFolderManage.vue?vue&type=script&setup=true&lang=js"
export * from "./VODFolderManage.vue?vue&type=script&setup=true&lang=js"

import "./VODFolderManage.vue?vue&type=style&index=0&id=58492962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58492962"],['__file',"src/views/VodDash/VODFolderManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58492962"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58492962', __exports__)) {
    api.reload('58492962', __exports__)
  }
  
  module.hot.accept("./VODFolderManage.vue?vue&type=template&id=58492962&scoped=true", () => {
    api.rerender('58492962', render)
  })

}


export default __exports__